(function ($, ns) {
    "use strict";

    var ThemeMap = function (context, opts, init) {
      this.$context = (context instanceof jQuery) ? context : $(context);

      this.map = null;
      this.panel = null;
      this.panelCache = {};

      if (opts) { this.opts = $.extend(this.getDefaultOpts(), opts); }

      if (init !== false && !$('body').hasClass('wp-admin')) {
        this.init();
      }
    };

    var parentPrototype = window.pew.getRegistryEntry('wdf-plugin-map').classDef.prototype;
    ThemeMap.prototype = jQuery.extend({}, parentPrototype);

    ThemeMap.prototype.getSizes = function (col) {
      let sizes = [32, 32];
      if (col.id === 2) {
        sizes = [27, 45];
      }
      return sizes;
    };
    ThemeMap.prototype.getHoverPopin= function (marker) {
      let offset = new google.maps.Size(0, 0);
      if(marker.data.col===2){
        offset = new google.maps.Size(0, -7);
      }
      return new google.maps.InfoWindow({
        content: this.getHoverPopinContent(marker),
        pixelOffset: offset,
        // Assign a maximum value for the width of the infowindow allows
        // greater control over the various content elements
        maxWidth: 350
      });
    };
    ThemeMap.prototype.markerClicked= function (marker) {
      return false;
    };

    window.pew.addRegistryEntry({key: 'wdf-plugin-map', domSelector: '.map-form, .module-map', classDef: ThemeMap});

  }
)(jQuery, window.wonderwp);



// WEBPACK FOOTER //
// ./web/app/themes/wwp_child_theme/plugins/wwp-map/public/js/map-child.js